import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    FilteredTextColumn,
    FilteredTextCommaColumn,
    FilteredDateColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('ID', 'id').withShow(false),
        new FilteredTextCommaColumn('Operator', 'operators'),
        new FilteredTextColumn('User Name', 'name'),
        new FilteredTextColumn('User Email', 'email'),
        new FilteredTextCommaColumn('User Type', 'types'),
        new FilteredTextColumn('Status', 'status'),
        new FilteredDateColumn('Last Usage', 'lastUsageDate'),
      ],
    },
  ];
};
